<template>
    <div class="HollowWrapper">
        <div class="sliderWrapper">
            <div class="d-flex align-items-center justify-content-center">
                <label class="d-block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-0 text-left w-24 !mb-0 !text-2xs">
                    intensity
                </label>
                <div class="flex-1">
                    <input type="range" @input="setThickness" :value="thickness" min="1" max="100" class="form-control-range" />
                </div>
                <div class="w-8 text-sm font-bold text-right text-gray-700 ml-2">{{thickness}}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
name:"HollowEffect",
data(){
    return{
        thickness:"50"
    }
},
computed:{
        getObjProperties(){
            return this.$store.getters.getActiveObjectprops
        },
       
    },
    watch:{
        getObjProperties :{
          handler(updatedValues) {
            
            this.thickness = updatedValues.effectType.thickness;
         
                
            },
            deep: true,
            immediate: true
        }
    },
methods:{
    setThickness(e){
        if(e.target.value > 3){
            this.thickness = e.target.value;
        this.$store.dispatch("setCurrentObjectProperties" , { effectType: this.Hollow() });
        } else { 
            this.thickness = 50;
        }
        
    },
    Hollow(){
            
            let obj = {
              type:"hollow",
                thickness:this.thickness
            };
  
              return obj
          },
}
}
</script>